import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
export const GetAllVendorRatesAsCsvApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema,
    response: z.object({
        url: z.string(),
    }),
};
